import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import arrowDown from "../../../assets/images/eoro-2024/arrow-down-yellow.svg"
import SmallLoader from "../../SmallLoader";

const GoldenTeamSelection = (props) => {
    const {
        isMobile,
        leagueTeams,
        selectedGoldenTeam,
        setSelectedGoldenTeam,
        edit,
        myGoldenTeam,
    } = props;

    const [modalVisible, setModalVisible] = useState(false);
    const [teamName, setTeamName] = useState(myGoldenTeam?.name || "");

    // console.log("myGoldenTeam is >>>", myGoldenTeam)
    // console.log("teamName >>", teamName)

    const renderMobile = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-center"}>
                    <div className={"w-100 d-flex flex-column align-items-center justify-content-center gap-3"}>
                        <div className={"cabin fw-700 font-25 text-skins-gold"}>
                            {edit ? "Edit" : "Select"} Your Golden Team
                        </div>
                        <div
                            className={"w-100 input-select-gold d-flex align-items-center justify-content-between p-2"}
                            role={"button"}
                            onClick={() => {
                                setModalVisible(true);
                            }}
                        >
                            <div>{teamName ? <>{teamName}</> : <>Select Golden Team</>}</div>
                            <img
                                src={arrowDown}
                                className="img-fluid"
                                alt={"icon"}/>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-center"}>
                    <div className={"w-100 d-flex flex-column align-items-center justify-content-center gap-3"}>
                        <div className={"cabin fw-700 font-43 text-skins-yellow"}>
                            {edit ? "Edit" : "Select"} Your Golden Team
                        </div>
                        <div
                            className={"w-50 input-select-yellow d-flex align-items-center justify-content-between p-2"}
                            role={"button"}
                            onClick={() => {
                                setModalVisible(true);
                            }}
                        >
                            <div>{teamName ? <>{teamName}</> : <>Select Golden Team</>}</div>
                            <img
                                src={arrowDown}
                                className="img-fluid"
                                alt={"icon"}/>
                        </div>
                        {/*<Form.Select className={"w-50 input-select-yellow"} onChange={handleTeamChange}*/}
                        {/*             value={selectedGoldenTeam}>*/}
                        {/*    <option value="">Select Golden Team</option>*/}
                        {/*    {leagueTeams?.map((team, index) => (*/}
                        {/*        <option*/}
                        {/*            key={index}*/}
                        {/*            value={team?.goalserve_id}*/}
                        {/*        >*/}
                        {/*            {team?.name}*/}
                        {/*        </option>*/}
                        {/*    ))}*/}
                        {/*</Form.Select>*/}
                    </div>
                </div>
            </>
        );
    }
    const render = () => {
        return (
            <section
            >
                {isMobile ? renderMobile() : renderDesktop()}
                {
                    modalVisible &&
                    <>
                        <Modal
                            backdrop="static"
                            size={isMobile ? "sm" : "lg"}
                            show={modalVisible} onHide={() => setModalVisible(false)}
                            scrollable
                        >
                            <Modal.Header
                                className={"bg-modal-header-yellow"}
                                closeButton
                            >
                                <Modal.Title className={'fw-bold font-20 cabin'}>
                                    Choose your golden team
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {leagueTeams?.map((team, index) => (

                                    <div key={index}>
                                        <div role={"button"}
                                             className={"text-black"}
                                             onClick={() => {
                                                 setSelectedGoldenTeam(team?.goalserve_id)
                                                 setModalVisible(false);
                                                 setTeamName(team?.name)
                                             }}
                                        >
                                                <span className={'font-18 text-blue cabin'}>
                                                    {team?.name}
                                                </span>
                                        </div>
                                        <hr/>
                                    </div>
                                ))}
                            </Modal.Body>
                        </Modal>
                    </>
                }
            </section>
        );
    }

    return render();
}

export default GoldenTeamSelection;
